/**
 * 拾取面剖切对话框管理器
 * 负责管理拾取面剖切工具对话框的显示和交互
 */
import { BaseDialogManager } from '../core/base-dialog-manager';
import { ManagerRegistry } from '../core/manager-registry';
import { SectionPlanePanel } from '../components/section-plane-panel';

/**
 * 拾取面剖切对话框管理器
 * 继承自 BaseDialogManager，提供拾取面剖切功能的对话框管理
 */
export class SectionPlaneDialogManager extends BaseDialogManager {
    /** 剖切面板实例 */
    private panel: SectionPlanePanel | null = null;

    constructor(registry: ManagerRegistry) {
        super(registry);
    }

    /** 对话框唯一标识 */
    protected get dialogId() { return 'section-plane-dialog'; }
    /** 对话框标题（国际化 key） */
    protected get dialogTitle() { return 'sectionPlane.dialogTitle'; }
    /** 对话框宽度 */
    protected get dialogWidth() { return 240; }
    /** 对话框高度 */
    protected get dialogHeight(): number { return 120; }

    /** 初始化 */
    public init(): void { }

    /**
     * 获取对话框位置
     * 定位在容器右下角
     */
    protected getDialogPosition() {
        const container = this.registry.container;
        if (!container) return { x: 100, y: 100 };

        const paddingRight = 20;
        const paddingBottom = 50;
        const containerWidth = container.clientWidth;
        const containerHeight = container.clientHeight;

        return {
            x: containerWidth - this.dialogWidth - paddingRight,
            y: containerHeight - this.dialogHeight - paddingBottom
        };
    }

    /** 创建对话框内容 */
    protected createContent(): HTMLElement {
        this.panel = new SectionPlanePanel({
            defaultHidden: false,
            defaultFill: this.engineComponent?.getFillCutFace() ?? false,
            onHideToggle: (isHidden) => {
                console.log('[SectionPlaneDialogManager] 隐藏切换：', isHidden);
                if (isHidden) {
                    this.engineComponent?.hideSection();
                } else {
                    this.engineComponent?.recoverSection();
                }
            },
            onFillToggle: (isFilled) => {
                this.engineComponent?.setFillCutFace(isFilled);
            },
            onReverse: () => {
                this.engineComponent?.reverseSection();
            },
            onReset: () => {
                // 先关闭剖切再开启
                this.engineComponent?.deactivateSection();
                this.engineComponent?.activeSection('face');
            }
        });
        this.panel.init();
        return this.panel.element;
    }

    /** 对话框创建后的回调 */
    protected onDialogCreated(): void {
        this.engineComponent?.activeSection('face');
        this.dialog?.fitHeight(false);
    }

    /** 对话框关闭时的回调 */
    protected onDialogClose(): void {
        this.registry.toolbar?.setBtnActive('section-plane', false);
    }

    /** 销毁前的清理 */
    protected onBeforeDestroy(): void {
        this.engineComponent?.deactivateSection();
        if (this.panel) {
            this.panel.destroy();
            this.panel = null;
        }
    }
}
